import "./LocalSeoConsultantDundee.module.css";
import Header from "@/reusable_sections/Header";
import Services from "./sections/Services";
import Industrysectorsgrid from "./sections/Industrysectorsgrid";
import CaseStudies from "./sections/CaseStudies";
import Positioning from "./sections/Positioning";
import Methodology from "./sections/Methodology";
import Localhero from "./sections/Localhero";
import Benefits from "./sections/Benefits";
import Dundee from "./sections/Dundee";
import Consultation from "./sections/Consultation";
import DundeeFaq from "./sections/DundeeFaq";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantDundeePage() {
  return <div>
      <Header />
      <Services />
      <Industrysectorsgrid />
      <CaseStudies />
      <Positioning />
      <Methodology />
      <Localhero />
      <Benefits />
      <Dundee />
      <Consultation />
      <DundeeFaq />
      <Footer />
    </div>;
}